import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getErrorMessage } from "../../../../utils/GeneralUtils";
import { newToastEvent } from "../../../../utils/ToastUtil";
import TenantAPI from "../../../../api/api/TenantAPI";

const useDeleteOrphanCollection = () => {
  const queryClient = useQueryClient();

  const deleteOrphanCollection = useMutation({
    mutationFn: async ({
      collectionName,
      tenantID,
    }: {
      collectionName: string;
      tenantID?: string;
      onSuccess?: () => void;
      onError?: () => void;
    }) => {
      return TenantAPI.deleteOrphanCollection(collectionName, tenantID);
    },
    onSuccess: (_, {}) => {
      queryClient.invalidateQueries({ queryKey: ["orphan-collections"] });

      newToastEvent("success", "Successfully deleted orphan collection.");
    },
    onError: (error) => {
      newToastEvent("error", getErrorMessage(error));
    },
  });

  return {
    deleteOrphanCollection: deleteOrphanCollection.mutate,
    deleteLoading: deleteOrphanCollection.isPending,
    deleteError: deleteOrphanCollection.error
      ? getErrorMessage(deleteOrphanCollection.error)
      : null,
  };
};

export default useDeleteOrphanCollection;
